/**
 * @flow
 * @relayHash 45616901cd279c7b511f05c835639bf4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateLotInput = {|
  id: string,
  lotNumber?: ?string,
  binNumber?: ?string,
  expiresAt?: ?any,
  warehouseLocationId?: ?string,
|};
export type UpdateLotMutationVariables = {|
  input: UpdateLotInput
|};
export type UpdateLotMutationResponse = {|
  +updateLot: {|
    +lotEdge: {|
      +node: {|
        +id: string,
        +lotNumber: string,
        +binNumber: ?string,
        +expiresAt: ?any,
        +warehouseLocation: ?{|
          +id: string,
          +name: string,
        |},
      |}
    |}
  |}
|};
export type UpdateLotMutation = {|
  variables: UpdateLotMutationVariables,
  response: UpdateLotMutationResponse,
|};
*/


/*
mutation UpdateLotMutation(
  $input: UpdateLotInput!
) {
  updateLot(input: $input) {
    lotEdge {
      node {
        id
        lotNumber
        binNumber
        expiresAt
        warehouseLocation {
          id
          name
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateLotInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateLot",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateLotPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "lotEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "LotEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Lot",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lotNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "binNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expiresAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "warehouseLocation",
                "storageKey": null,
                "args": null,
                "concreteType": "WarehouseLocation",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateLotMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateLotMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateLotMutation",
    "id": null,
    "text": "mutation UpdateLotMutation(\n  $input: UpdateLotInput!\n) {\n  updateLot(input: $input) {\n    lotEdge {\n      node {\n        id\n        lotNumber\n        binNumber\n        expiresAt\n        warehouseLocation {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6cb1f4fe072de9e8dcc0c18bccd588b1';
module.exports = node;
